import React, { Component } from 'react';
import { partnerApi, partnerBranch, partnerUpdateBranch, fetch_category_by_ids } from '../../../../API/FetchCall';
import swal from 'sweetalert';
import Autosuggest from 'react-autosuggest';
import { MOBILE_REGEX, URL_REGEX } from '../../../../constant.js';
import ReactTooltip from "react-tooltip";
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import SimpleReactValidator from 'simple-react-validator';
import DataTable from 'react-data-table-component';
//$.DataTable = require('datatables.net')
const $ = require('jquery')
/*
{ data: 'org_name' },
{ data: 'email_id' },
{ data: 'category_name' },
{ data: 'branch' },
{ data: 'action' },
*/
const customStyles = {
    headCells: {
      style: {
        fontWeight: 'bold'
      },
    },
  };
  
const columns_af = [
    {
      name: 'Org',
      selector: row => row.org_name,
      sortable: true,
    },
    {
      name: 'No of Persons',
      selector: row => row.email_id,
    },
    {
      name: 'Month',
      selector: row => row.category_name,
    },
    {
        name: 'Month',
        selector: row => row.branch,
      },
      {
        name: 'Month',
        selector: row => row.action,
      },
  ];

class Branch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editclicked:false,
            suggestions: [],
            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
            master_data: [],
            uids: [],
            cids: [],
            cat_list:[],
            selected_cids:[],
            sub_category: [],
            type_one: [],
            dataSet:[],
            type_two: [],
            first_category: [],
            second_category: [],
            third_category: [],
            button: 'Submit',
            location_list: [],
            spartner_list: [],
            social_link_data: [{ id: "li", name: 'LinkedIn', link: "" },
            { id: "fb", name: 'Facebook', link: "" }, { id: "in", name: 'Instagram', link: "" }],
            e_social_link_data: [{ id: "li", name: 'LinkedIn', link: "" },
            { id: "fb", name: 'Facebook', link: "" }, { id: "in", name: 'Instagram', link: "" }],
            autosaveddata: []
        }

        this.validator = new SimpleReactValidator({
            validators: {
              checkMobile: MOBILE_REGEX,
              checkUrl: URL_REGEX
            }
        }); 

        this.getpageData();
        this.getCategories = this.getCategories.bind(this);
        this.goBack = this.goBack.bind(this);
    }


    getCategories = (cids) => {

    let req = JSON.stringify({
      cids: cids
    });

    fetch_category_by_ids(req).then(res => {

      if (res.status === 1) {
        let cat_list = res.category_data;
        this.setState({
          cat_list: cat_list.result
        })

      }
     

    });

   }

   onChange = (event, { newValue, method }) => {
    this.setState({
        e_org_name: newValue
    });
  };

   onChange_e = (event, { newValue, method }) => {
    this.setState({
        e_org_name: newValue
    });
  };
 
   handlePaste = (e) => {
    this.Geocode_location();
   };
  
  
   handlePaste = (e) => {
    this.Geocode_location();
  };
  handleChange = (e) => {
    const propName = e.target.name;
    this.setState({ [e.target.name]: e.target.value });
  };
  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
  };
  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  shouldRenderSuggestions = (value, reason) => {
    return value.trim().length > 2;
  };
  onSuggestionsFetchRequested = ({ value }) => {
    const val = this.escapeRegexCharacters(value.trim());
    let login_id = this.state.user_data.login_id;
    let fetch = JSON.stringify({
      keyword: val,
      login_id: login_id,
      url: 'getDataByName'
    });
    partnerApi(fetch).then(res => {
      if (res.status == 1) {
        this.setState({
          suggestions: res.result
        });
      }
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  getSuggestionValue = (suggestion) => {
    this.setState({ confirmModal: true });
    let currentData = suggestion;
    currentData.url = 'getDataById';
    let data = JSON.stringify(currentData);
    partnerApi(data).then(res => {
      if (res.status === 1) {
        let data = res.result;
        this.setState({
          registration_no: data.organisation_register_number,
          address: data.address,
          google_address: data.google_address,
          city: data.location,
          state: data.state,
          pincode: data.pin_code,
          contact_number: data.institution_contact_number,
          email: data.institution_email_address,
          social_media: data.social_link,
          social_media_link: data.social_media_link,
          social_link_data: data.social_link_data ? JSON.parse(data.social_link_data) : this.state.social_link_data,
        });
      } else {
        this.setState({
          registration_no: '',
          address: '',
          google_address: '',
          city: '',
          state: '',
          pincode: '',
          contact_number: '',
          email: '',
          social_media: '',
          social_media_link: '',
          social_link_data: this.state.social_link_data,
        });
      }
    });
    return suggestion.name;
  }

  renderSuggestion(suggestion) {
    return (
      <span>{suggestion.name}</span>
    );
  }


   goBack(){
            this.setState({editclicked:false});
            this.getpageData();

   }

    componentDidMount() {
        var THIS = this;
        $(document).on('click', '.deletebranch', function () {
            var delete_id = $(this).data("id");
            THIS.setState({
                delete_id: delete_id
            });
            THIS.deleteBranch(delete_id);
        });

        $(document).on('click', '.editbranch', function () {
            var edit_id = $(this).data("vendor_id");
            THIS.setState({
                e_vendor_id:edit_id,
                editclicked: true
            });
            THIS.getEditProfileData();
            //THIS.deleteBranch(delete_id);
        });

    }

    

    getEditProfileData = () => {
        const { user_type } = this.state.user_data;
        const { e_vendor_id } = this.state;

    let req = JSON.stringify({
      vendor_id: e_vendor_id,
      url: 'getSpecificVendorInfo'
    });
    partnerApi(req).then(res => {
      if (res.status === 1) {
        let data = res.result;
        //this.Geocode_location(data.address);

        if (user_type === 1) {
          this.setState({
            e_vendor_id : data.vendor_id,
            e_registration_no: data.organisation_register_number,
            e_org_name: data.organisation_name,
            e_temp_org_name: data.organisation_name,
            e_first_name: '',
            e_last_name: '',
            e_address: data.address,
            e_temp_org_address: data.address,
            e_google_address: data.address,
            e_city: data.location,
            e_state: data.state,
            e_pincode: data.pin_code,
            e_email: data.institution_email_address,
            e_social_link_data: data.social_link_data ? JSON.parse(data.social_link_data) : this.state.social_link_data,
            e_contact_number: data.phone_number,
            e_landline: data.landline_number,
            e_social_media: data.social_link,
            e_social_media_link: data.social_media_link,
            e_main_access: data.main_access
             
          });
        } else if (user_type === 2) {
          this.setState({
            e_vendor_id:data.vendor_id,
            e_main_id: data.main_id ? data.main_id : 0,
            e_registration_no: '',
            e_org_name: '',
            e_first_name: data.first_name,
            e_last_name: data.last_name,
            e_address: data.address,
            e_google_address: data.address,
            e_city: data.location,
            e_state: data.state,
            e_pincode: data.pin_code,
            e_email: data.email_id,
            e_contact_number: data.phone_number,
            e_landline: data.landline_number,
            e_social_media: data.social_link,
            e_social_media_link: data.social_media_link,
            e_main_access: data.main_access
            
          });
        }
        this.setState({
            e_location_list: res.location,
            e_master_data: data.master_data,
            e_uids: data.uids,
            e_cids: data.cids
        })

        this.getCategories(data.cids);
      }

    });
  }


  getProfileData = () => {
    const { user_type, vendor_id, login_id, is_completd, current_category, set_id } = this.state.user_data;

    let req = JSON.stringify({
      vendor_id: vendor_id,
      url: 'getSpecificVendorInfo'
    });
    partnerApi(req).then(res => {
      if (res.status === 1) {
        let data = res.result;
        this.Geocode_location(data.address);

        if (user_type === 1) {
          this.setState({
            vendor_id : data.vendor_id,
            registration_no: data.organisation_register_number,
            org_name: data.organisation_name,
            temp_org_name: data.organisation_name,
            first_name: '',
            last_name: '',
            address: data.address,
            temp_org_address: data.address,
            google_address: data.address,
            city: data.location,
            state: data.state,
            pincode: data.pin_code,
            email: data.institution_email_address,
            social_link_data: data.social_link_data ? JSON.parse(data.social_link_data) : this.state.social_link_data,
            contact_number: data.phone_number,
            landline: data.landline_number,
            social_media: data.social_link,
            social_media_link: data.social_media_link,
            main_access: data.main_access,
            is_completd: data.is_completd,
          });
        } else if (user_type === 2) {
          this.setState({
            vendor_id:data.vendor_id,
            main_id: data.main_id ? data.main_id : 0,
            registration_no: '',
            org_name: '',
            first_name: data.first_name,
            last_name: data.last_name,
            address: data.address,
            google_address: data.address,
            city: data.location,
            state: data.state,
            pincode: data.pin_code,
            email: data.email_id,
            contact_number: data.phone_number,
            landline: data.landline_number,
            social_media: data.social_link,
            social_media_link: data.social_media_link,
            main_access: data.main_access,
            is_completd: data.is_completd,
          });
        }
        this.setState({
          location_list: res.location,
          master_data: data.master_data,
          uids: data.uids,
          cids: data.cids
        })

        this.getCategories(data.cids);
      }

    });
  }


    getpageData = async () => {
        const { user_type, login_id } = this.state.user_data;
        let insdata = JSON.stringify({
            user_type: user_type,
            login_id: login_id,
            role: 3,
            url: 'getBranch'
        });
        await partnerBranch(insdata).then((response) => {
            if (response.status === 1) {
                this.setState({
                    dataSet: response.data
                })
                //this.datatabledata(response.data);
            }
        });
    }
    datatabledata(data) {
        console.log('data', data)
        this.setState({
            dataSet: data
        })
        this.el = $(this.el)
        this.el.DataTable(
            {
                data: this.state.dataSet,
                columns: [
                    { data: 'org_name' },
                    { data: 'email_id' },
                    { data: 'category_name' },
                    { data: 'branch' },
                    { data: 'action' },
                ]

            }
        )
    }
    deleteBranch = (delid) => {
        swal({
            title: "Are you sure to Delete Branch?",
            text: "",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    let user_data = this.state.user_data;
                    console.log('user_data', user_data)
                    let req = JSON.stringify({
                        login_id: user_data.login_id,
                        set_id: delid,
                        role: 3,
                        url: 'deleteBranch'
                    });
                    partnerBranch(req).then((res) => {
                        let toastr = '';
                        if (res.status === 1) {
                            alert("success");
                            /*
                            toastr = window.toastr.success;
                            toastr('', res.message, {
                                positionClass: "toast-bottom-right",
                                containerId: "toast-bottom-right"
                            });
                            */
                            setTimeout(function () {
                                window.location.reload();
                            }, 1000);
                        } else {
                            alert("failure");
                            /*
                            toastr = window.toastr.error; 
                            toastr('', res.message, {
                                positionClass: "toast-bottom-right",
                                containerId: "toast-bottom-right"
                            });
                            */
                        }
                    });
                }
            });
    }
    render() {

        this.validator.purgeFields();
        const { user_type, user_data, suggestions, cat_list } = this.state;
        let add_type = user_type == 1 ? ' Of the Institution' : '';
        let type = user_type == 1 ? ' Institution' : '';
        const inputProps = {
          value: this.state.org_name ? this.state.org_name : '',
          onChange: this.onChange,
          name: 'org_name',
          className: 'form-control'
        };

        const e_inputProps = {
            value: this.state.e_org_name ? this.state.e_org_name : '',
            onChange: this.onChange_e,
            name: 'e_org_name',
            className: 'form-control'
          };
        
        return (
            <React.Fragment>
                <div class="box-shadow-custom">
                    {/* <h1>Branches</h1> */}
                    <div className='col-md-12'>
                        {!this.state.editclicked &&
                        <div className='row'>
                            <div className="table-responsive custom-table-wrap content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                                <table className="table dataTable" ref={el => this.el = el}>
                                    <thead>
                                        <tr role="row">
                                            <th className="tabledata">Name</th>
                                            <th className="tabledata">Login Id</th>
                                            <th className="tabledata">Categories</th>
                                            <th className="tabledata">Branch/Location</th>
                                            <th className="tabledata">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.dataSet.map((eachbranch, index) => (                                         
                                        <tr>
                                            <td>{eachbranch.org_name}</td>
                                            <td>{eachbranch.email_id}</td>
                                            <td>{eachbranch.category_name}</td>
                                            <td>{eachbranch.branch}</td>
                                            <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html: eachbranch.action}}></td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>

                              
                            </div>
                        </div>
                        }
                        {this.state.editclicked &&
                        <div class="row">
                            <div class="flexrow">
                                <div class="headertitle">Editing</div>
                                <div class="goback"><button class="btn btn-primary" onClick={this.goBack}>Go Back</button></div>
                            </div>
                            <form onSubmit={this.submitForm} autoComplete='off' >
                        <div class="box-shadow-custom">

                        
                            <div className='row'>
                            <div class="form-group col-md-4">
                                <label>Name of the Institution <span class="astrick">*</span></label>
                                {/* <input type="text"
                                class="form-control" name="org_name"
                                value={this.state.org_name}
                                onChange={this.handleChange} /> */}
                                <Autosuggest
                                suggestions={suggestions}
                                shouldRenderSuggestions={this.shouldRenderSuggestions}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={e_inputProps} />
                                {this.validator.message('Name of the Institution', this.state.e_org_name, 'required', { className: 'text-danger' })}
                            </div>
                            <div class="form-group col-md-4">
                                <label>Business Registration Number <span class="astrick">*</span></label>
                                <input type="text"
                                class="form-control" name="registration_no"
                                value={this.state.e_registration_no}
                                onKeyUp={this.autoSave}
                                onChange={this.handleChange} />
                                {this.validator.message('Business Registration Number', this.state.e_registration_no, 'required|alpha_num', { className: 'text-danger' })}
                            </div>

                            <div class="form-group col-md-4">
                            <label>Category <span class="astrick">*</span></label>
                            <select className="form-control selectpicker"
                                    title={"Select Category"}
                                    name="selected_cids"
                                    multiple
                                    onChange={this.handleSelect}>
                                    {
                                    cat_list.map((item, k) => {
                                        return (
                                            <option value={item.category_id} >{item.category_name}</option>
                                        )
                                    })
                                    }
                            </select>
                            {this.validator.message('Category', this.state.selected_cids, 'required', { className: 'text-danger' })}
                            </div>    


                            </div>
                        
                        
                            <div className='row'>
                            <div class="form-group col-md-4">
                                <label>Name <span class="astrick">*</span></label>
                                <input type="text"
                                class="form-control" name="first_name"
                                value={this.state.e_first_name}
                                onKeyUp={this.autoSave}
                                onChange={this.handleChange} />
                                {this.validator.message('First Name', this.state.first_name, 'required', { className: 'text-danger' })}
                            </div>
                            {/* <div class="form-group col-md-4">
                                <label>Last Name <span class="astrick">*</span></label>
                                <input type="text"
                                class="form-control" name="last_name"
                                value={this.state.last_name}
                                onKeyUp={this.autoSave}
                                onChange={this.handleChange} />
                                {this.validator.message('Last Name', this.state.last_name, 'required|alpha_num', { className: 'text-danger' })}
                            </div> */}
                            </div>
                        
                        <div className='row'>
                            <div class="form-group col-md-6">
                            <label>Address {add_type} <span class="astrick">*</span></label>
                            <input type="text"
                                class="form-control" name="address"
                                value={this.state.e_address}
                                onKeyUp={this.autoSave}
                                onChange={this.handleChange} />
                            {this.validator.message('Address' + add_type, this.state.e_address, 'required', { className: 'text-danger' })}
                            </div>
                            <div class="form-group col-md-6">
                            <label>Google Location <i class="fa fa-info-circle info-tool" data-tip data-for="info-goole" aria-hidden="true"></i>
                                    <ReactTooltip id="info-goole" place="bottom" effect="solid" className='react_tooltip_backgrnd'>
                                        <p>https://www.google.com/maps"</p>
                                    </ReactTooltip> <span class="astrick">*</span></label>
                            <input type="text"
                                class="form-control" name="google_address"
                                value={this.state.e_google_address}
                                onKeyUp={this.autoSave}
                                onChange={this.handleChange} />
                            {this.validator.message('Google Location', this.state.e_google_address, 'required', { className: 'text-danger' })}
                            </div>
                        </div>
                        <div className='row'>
                            <div class="form-group col-md-4">
                            <label>City <span class="astrick">*</span></label>
                            <select className="form-control selectpicker"
                                title={"Select"}
                                name="city"
                                onChange={this.handleChange}
                                onKeyUp={this.autoSave}
                                value={this.state.e_city}>
                                {
                                this.state.location_list.map((item, i) => {
                                    return (
                                    <option key={i + 'L'}>{item.location}</option>
                                    )
                                })
                                }
                            </select>
                            {this.validator.message('City', this.state.e_city, 'required', { className: 'text-danger' })}
                            </div>

                            <div class="form-group col-md-4">
                            <label>State <span class="astrick">*</span></label>
                            <input type="text"
                                class="form-control" name="state"
                                value={this.state.e_state}
                                onKeyUp={this.autoSave}
                                onChange={this.handleChange} />
                            {this.validator.message('state', this.state.e_state, 'required|alpha_num', { className: 'text-danger' })}
                            </div>
                            <div class="form-group col-md-4">
                            <label>Pincode <span class="astrick">*</span></label>
                            <input type="text"
                                class="form-control" name="pincode"
                                value={this.state.e_pincode}
                                onKeyUp={this.autoSave}
                                onChange={this.handleChange} />
                            {this.validator.message('pincode', this.state.e_pincode, 'required|numeric|min:1,num', { className: 'text-danger' })}
                            </div>
                        </div>
                        <div className='row'>
                            <div class="form-group col-md-4">
                            <label>{type} Email Address <span class="astrick">*</span></label>
                            <input type="text"
                                class="form-control" name="email"
                                value={this.state.e_email}
                                onKeyUp={this.autoSave}
                                onChange={this.handleChange} />
                            {this.validator.message(type + 'Email Address', this.state.e_email, 'required|email', { className: 'text-danger' })}
                            </div>
                            <div class="form-group col-md-4">
                            <label>{type} Contact Number <span class="astrick">*</span></label>
                            <div className="phone-wrapper">
                                <div className="custom-select-drop dropdown">
                                <select className="form-control selectpicker">
                                    <option>+91</option>
                                </select>
                                </div>
                                <input type="text" name="contact_number"
                                placeholder=""
                                onKeyUp={this.autoSave}
                                value={this.state.e_contact_number}
                                onChange={this.handleChange} className="form-control" />

                            </div>
                            {this.validator.message(type + 'Contact Number', this.state.contact_number, 'required|checkMobile|min:10|max:50', { className: 'text-danger' })}
                            </div>
                            <div class="form-group col-md-4">
                            <label>{type} Landline </label>
                            <input type="text"
                                class="form-control" name="landline"
                                value={this.state.e_landline}
                                onKeyUp={this.autoSave}
                                onChange={this.handleChange} />
                            {this.validator.message(type + 'Landline', this.state.e_landline, 'numeric', { className: 'text-danger' })}
                            </div>
                        </div>
                        <div className="row">
                            <div class="form-group col-md-12">
                            <label> Social Links <span className="astrick">*</span></label>
                            <table className='table socialtable desktoponly'>
                                <tbody>
                                <tr>
                                    <td><b>Media</b></td>
                                    {this.state.e_social_link_data.map((item, i) => {
                                    return (
                                        <td>{item.name}</td>
                                    )
                                    })}
                                </tr>
                                <tr>
                                    <td><b>Link</b> <i class="fa fa-info-circle info-tool" data-tip data-for="info" aria-hidden="true"></i>
                                    <ReactTooltip id="info" place="bottom" effect="solid" className='react_tooltip_backgrnd'>
                                        <p>Please start with "https://...."</p>
                                    </ReactTooltip>
                                    </td>
                                    {this.state.e_social_link_data.map((item, i) => {
                                    return (
                                        <td>
                                        <input type='text' className='form-control' onChange={(e) => this.customChange(e, i)}
                                            value={item.link} />
                                        {this.validator.message(item.name, item.link, 'url', { className: 'text-danger' })}
                                        </td>
                                    )
                                    })}
                                </tr>
                                
                                </tbody>
                            </table>
                            <table className='table socialtable mobileonly'>
                                <tbody>
                                <tr><th><b>Media</b></th><th><b>Link</b></th></tr>
                                
                                    {this.state.e_social_link_data.map((item, i) => {
                                    return (
                                        <tr>
                                        <td>{item.name}</td>
                                        <td>
                                        <input type='text' className='form-control' onChange={(e) => this.customChange(e, i)}
                                            value={item.link} />
                                        {this.validator.message(item.name, item.link, 'url', { className: 'text-danger' })}
                                        </td>
                                        </tr>
                                    )
                                    })}
                                
                                </tbody>
                            </table>
                            </div>
                        </div>

                        </div>
                        <div className='box-shadow-custom'>
                        <h5 className='astrick'><b>Notes</b></h5>
                        <ul>
                        <li>Please suffix location to the name of the institution when you add a branch or category</li>
                        <li>If you need help - please write to us at contact@bewise.in</li>
                        </ul>
                        </div>

                        <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
                        <button type='submit' id="btnSubmit"
                            className="btn btn-primary btn-sm" disabled={this.state.btnDisabled}>
                            {this.state.button}
                        </button>
                        </div>
                        </form> </div>                            
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }



    submitForm = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {

          //console.log(this.state.selected_cids);

          if(this.state.e_org_name==this.state.temp_org_name){

            console.log("Same name");
            NotificationManager.error("Name should not be the same as Head Office");

          }else if(this.state.e_address==this.state.temp_org_address){

            console.log("Address should not be same");
            NotificationManager.error("Branch Location and address should not be the same as Head Office");

          }else{ 

          const { user_type, login_id } = this.state.user_data;
          let request = JSON.stringify({
            vendor_id:this.state.vendor_id,
            user_type: user_type,
            master_data: this.state.master_data,
            uids: this.state.uids,
            cids: this.state.cids,
            selected_cids:this.state.selected_cids, 
            login_id: login_id,
            is_completd: this.state.is_completd,
            registration_no: this.state.registration_no,
            org_name: this.state.e_org_name,
            first_name: this.state.e_first_name,
            city: this.state.e_city,
            state: this.state.e_state,
            pincode: this.state.e_pincode,
            email: this.state.e_email,
            contact_number: this.state.e_contact_number,
            landline: this.state.e_landline,
            social_media: this.state.e_social_media,
            social_media_link: this.state.e_social_media_link,
            social_link_data: JSON.stringify(this.state.social_link_data),
            access: this.state.access,
            sub_category: this.state.sub_category,
            main_access: this.state.main_access,
            type_one: this.state.type_one,
            type_two: this.state.type_two
          });

          //console.log(request);
          
          partnerUpdateBranch(request).then(res => {
            if (res.status === 1) {
                NotificationManager.success(res.message);
                this.setState({editclicked:false});
                

            } else {
                NotificationManager.error(res.message);
                this.setState({editclicked:true});
            }
          });
          

          }


        } else {
          this.validator.showMessages();
          this.forceUpdate();
        }
    }
    
}

export default Branch;





// WEBPACK FOOTER //
// ./src/components/bewise/partners/branch/branch.jsx